module.exports = __webpack_public_path__ + "media/components/src/assets/images/image_text/5-a6ab7ff852ed36cc94e8aa310c053dd7.jpg";